import React from 'react';
import LastMinuteGiftIcon from './LastMinuteGiftIcon';
import {
	Wrapper, Text
} from './lastMinuteStyles';
import PropTypes from 'prop-types';

const LastMinuteGift = ({ title, pdfUrl }) => {
	return (
		<Wrapper>
			<LastMinuteGiftIcon />
			<Text>
				<span>{title}</span>
				<br/>
				<a href={pdfUrl} target="_blank" rel="noreferrer">
					Download and print this note
				</a> to let them know their gift is on the way.
			</Text>
		</Wrapper>
	);
};

LastMinuteGift.propTypes = {
	pdfUrl: PropTypes.string,
	title: PropTypes.string,
};

LastMinuteGift.defaultProps = {
	title: "Last Minute Gift? No worries.",
	pdfUrl: "https://sell.cratejoy.com/wp-content/uploads/2022/03/Mothers-Day.pdf",
};

export default LastMinuteGift;
